const Home = () =>
  <>
    <h2>Em construção...</h2>
  </>

export default Home